/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerConfirmContactsMutationRequest,
  TelegramUsersControllerConfirmContactsMutationResponse,
  TelegramUsersControllerConfirmContacts400,
  TelegramUsersControllerConfirmContacts401,
  TelegramUsersControllerConfirmContacts429,
} from '../../types/TelegramUsersControllerConfirmContacts.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersConfirmContacts } from '../../methods/telegramUsersConfirmContacts.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersConfirmContactsMutationKey = () => [{ url: '/api/telegram/users/confirm-contacts' }] as const;

export type TelegramUsersConfirmContactsMutationKey = ReturnType<typeof telegramUsersConfirmContactsMutationKey>;

/**
 * {@link /api/telegram/users/confirm-contacts}
 */
export function useTelegramUsersConfirmContacts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerConfirmContactsMutationResponse,
      ResponseErrorConfig<
        | TelegramUsersControllerConfirmContacts400
        | TelegramUsersControllerConfirmContacts401
        | TelegramUsersControllerConfirmContacts429
      >,
      { data: TelegramUsersControllerConfirmContactsMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramUsersControllerConfirmContactsMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersConfirmContactsMutationKey();

  return useMutation<
    TelegramUsersControllerConfirmContactsMutationResponse,
    ResponseErrorConfig<
      | TelegramUsersControllerConfirmContacts400
      | TelegramUsersControllerConfirmContacts401
      | TelegramUsersControllerConfirmContacts429
    >,
    { data: TelegramUsersControllerConfirmContactsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramUsersConfirmContacts(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
